import React, { useState } from "react";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { BaseFormFields, useBaseForm } from "./BaseFormFields";

export function ProblemForm({ onSubmit, initialData, readOnly, submitting, onTitleChange, allowedPriorities, ticketType, onTypeChange }) {
    const baseForm = useBaseForm("medium");
    const [affectedSystems, setAffectedSystems] = useState("");
    const [rootCauseHypothesis, setRootCauseHypothesis] = useState("");
    const [linkedIncidents, setLinkedIncidents] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit({
            title: baseForm.title,
            description: baseForm.description,
            priority: baseForm.priority,
            dynamic_fields: {
                affected_systems: affectedSystems.split(",").map((s) => s.trim()).filter(Boolean),
                root_cause_hypothesis: rootCauseHypothesis,
                linked_incident_ids: linkedIncidents.split(",").map((s) => s.trim()).filter(Boolean),
            },
        });
    };

    return (
        <form onSubmit={handleSubmit}>
            <BaseFormFields
                ticketType={ticketType}
                onTypeChange={onTypeChange}
                {...baseForm}
                onTitleChange={onTitleChange}
                    allowedPriorities={allowedPriorities}
                titlePlaceholder="Ex: Lenteurs récurrentes réseau WiFi"
                descriptionPlaceholder="Décrivez le problème récurrent..."
            >
                <div className="form-group">
                    <Label className="form-label">Systèmes affectés</Label>
                    <Input
                        value={affectedSystems}
                        onChange={(e) => setAffectedSystems(e.target.value)}
                        placeholder="Séparez par des virgules: WiFi, Bornes AP-2E..."
                        data-testid="affected-systems"
                    />
                </div>

                <div className="form-group">
                    <Label className="form-label">Hypothèse de cause racine</Label>
                    <Textarea
                        value={rootCauseHypothesis}
                        onChange={(e) => setRootCauseHypothesis(e.target.value)}
                        placeholder="Quelle pourrait être la cause du problème ?"
                        data-testid="root-cause"
                    />
                </div>

                <div className="form-group">
                    <Label className="form-label">Incidents liés (numéros)</Label>
                    <Input
                        value={linkedIncidents}
                        onChange={(e) => setLinkedIncidents(e.target.value)}
                        placeholder="Ex: #2025-00001, #2025-00002"
                        data-testid="linked-incidents"
                    />
                </div>
            </BaseFormFields>

            <div className="mt-6 flex justify-end">
                <Button type="submit" disabled={!baseForm.title || submitting} data-testid="submit-ticket">
                    {submitting ? "Création..." : "Soumettre le ticket"}
                </Button>
            </div>
        </form>
    );
}
